export default {"src":"/_next/static/media/GEO.536543fa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};